import { render, staticRenderFns } from "./Uras.vue?vue&type=template&id=4605dda1&scoped=true"
import script from "./Uras.vue?vue&type=script&lang=js"
export * from "./Uras.vue?vue&type=script&lang=js"
import style0 from "./Uras.vue?vue&type=style&index=0&id=4605dda1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605dda1",
  null
  
)

export default component.exports